module.exports = __webpack_public_path__ + "static/media/blocker_detail.6c71502c.png";